module.exports = __webpack_public_path__ + "img/30_fineStaff_xf.806a2daf.png";